var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconHighlightHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_highlight_hover") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.564706 0 0 0 0 0.729412 0 0 0 0 0.811765 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.784314 0 0 0 0 0.866667 0 0 0 0 0.905882 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_highlight_hover",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)",
    id: "payments_black_24dp-copy-5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.000000, 20.000000)",
    filter: "url(#filter-2)",
    id: "Group-42"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.6363636,6.25 L10.6363636,1.25 C10.6363636,0.5625 10.1045455,0 9.45454545,0 L1.18181818,0 C0.531818182,0 0,0.5625 0,1.25 L0,6.25 C0,6.9375 0.531818182,7.5 1.18181818,7.5 L9.45454545,7.5 C10.1045455,7.5 10.6363636,6.9375 10.6363636,6.25 Z",
    id: "Path",
    fill: "#A3AFB7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,1.875 L13,8.75 C13,9.4375 12.4681818,10 11.8181818,10 L1.77272727,10 C1.77272727,9.375 1.77272727,9.4375 1.77272727,8.75 L11.8181818,8.75 L11.8181818,1.875 C12.4681818,1.875 12.4090909,1.875 13,1.875 Z",
    id: "Path",
    fill: "#A3AFB7",
    fillRule: "nonzero"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHighlightHover);
export default __webpack_public_path__ + "static/media/icon_highlight_hover.090f5362cd62aed5865cf2ca92cabea3.svg";
export { ForwardRef as ReactComponent };